module.exports = __webpack_public_path__ + "static/media/logoFuturosBrillantes.f9528a77.svg";